import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ProcessingStepCount } from "@managers/case.manager";

export const globalActions = createActionGroup({
	source: 'CaseHub Processing',
	events: {
		'Update Version': props<{ version: string }>(),
		'Update UI Version': props<{ uiVersion: string }>(),
		'Load Processing': emptyProps(),
		'Loaded Processing': props<{ processing: ProcessingStepCount[] }>(),
		'Error Loading Processing': emptyProps(),
	},
});
